import React from 'react';
import SolutionBoard from '../SolutionBoard';

// Lab · Solution phase ([[solution-engineering]]): the app seen as one
// component of the whole business service — apps and nQube workflows
// handing work to each other, checked against one set of requirements.
// The board itself is shared with the nQube module's Solutions view.
export default function Solution({ org, app, artifacts, canEdit, onPhase }) {
  return (
    <div className="lab-list is-wide" data-nova-note={`Solution phase for "${app.name}": the whole service — apps and nQube workflows handing work to each other, checked against one set of requirements. NoVA: engineer_solution (edit), solution_status (read), declare_requirement.`}>
      <SolutionBoard org={org} app={app} artifacts={artifacts} canEdit={canEdit} onPhase={onPhase} />
    </div>
  );
}
